export default '4.0.0-beta6';
